const TABLE_PLACEHOLDER = /\{\{TABLE:(\d+)\}\}/g;

// The tables a response's {{TABLE:n}} placeholders index into: the live chat keys them by
// thread, a scheduled response carries its own array.
export function responseTables(tables, threadId) {
  if (Array.isArray(tables)) return tables;
  return (threadId && tables?.[threadId]) || [];
}

// A streamed table reaches the response text only as {{TABLE:n}} — its rows live beside it.
// Send the tables this response shows, renumbered from 0, so the export reads the same data the
// download card does; a placeholder whose table is missing is dropped.
export function buildExcelExportPayload(text, tables) {
  const exported = [];
  const exportedIndex = new Map();

  const response = (text || "").replace(TABLE_PLACEHOLDER, (placeholder, n) => {
    if (!exportedIndex.has(n)) {
      const table = tables?.[Number(n)];
      const data = table?.content?.data;
      if (!Array.isArray(data?.columns)) return "";

      exportedIndex.set(n, exported.length);
      exported.push({
        title: table.title || null,
        columns: data.columns.map((column) => String(column ?? "")),
        rows: Array.isArray(data.data) ? data.data.filter(Array.isArray) : [],
      });
    }
    return `{{TABLE:${exportedIndex.get(n)}}}`;
  });

  return { response, tables: exported };
}
